import React, { ReactNode, useRef } from 'react';

export interface SectionProps {
  className?: string;
  children: ReactNode;
}

export function Section({ ...props }: SectionProps) {
  const ref = useRef(null);
  return (
    <section className={props.className} ref={ref}>
      {props.children}
    </section>
  );
}
